
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/virtual-sightseeing",
      function () {
        return require("private-next-pages/virtual-sightseeing/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/virtual-sightseeing"])
      });
    }
  